import { UrlSearchParam } from 'consts/url'
import { ValueOf } from 'types'

export const Region = {
  EU: 'eu',
  IN: 'in',
}
export type Region = ValueOf<typeof Region>

const DEFAULT_REGION: Region = Region.EU

export const RegionStore = (() => {
  const searchParams = new URLSearchParams(window.location.search)
  let currentRegion: Region = searchParams.get(UrlSearchParam.Region) ?? DEFAULT_REGION

  return {
    get region() {
      return currentRegion
    },

    setRegion(newRegion: Region) {
      currentRegion = newRegion
    },
  }
})()
